(function () {
  if (window.abFoursixtyGalleryLoaded) return;
  window.abFoursixtyGalleryLoaded = true;

  var rootSelector = '.ab-foursixty';
  var homepageSelector = '.ab-foursixty-gallery';
  var maxPostsDesktop = 12;
  var maxPostsMobile = 4;

  function maxPosts() {
    return window.matchMedia('(max-width: 749px)').matches ? maxPostsMobile : maxPostsDesktop;
  }

  function collapseGallery(root) {
    if (!root) return;

    root.querySelectorAll('.fs-wrapper, .fs-timeline, [id^="fs_"]').forEach(function (el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
    });

    var entries = root.querySelectorAll('.fs-entry-container');
    var limit = maxPosts();
    entries.forEach(function (entry, index) {
      entry.style.display = index >= limit ? 'none' : '';
      entry.style.setProperty('width', '100%', 'important');
      entry.style.setProperty('height', 'auto', 'important');
      entry.style.setProperty('padding', '0', 'important');
      entry.style.setProperty('aspect-ratio', '1 / 1', 'important');
    });

    root.querySelectorAll('.fs-next-page').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function initProductCarousels() {
    document.querySelectorAll('#fs-detail-products').forEach(function (productsRoot) {
      var existing = productsRoot.querySelector('.ab-fs-product-carousel');
      var links = Array.prototype.slice.call(productsRoot.querySelectorAll('.fs-shop-link'));
      var unwrapped = links.filter(function (link) {
        return !link.closest('.ab-fs-product-carousel');
      });

      if (existing && unwrapped.length === 0) return;
      if (links.length < 2) return;

      var slides = links.map(function (link) {
        var id = link.getAttribute('data-link-id');
        var options = id
          ? productsRoot.querySelector('.fs-shopify-options[data-link-id="' + id + '"]')
          : null;
        var slide = document.createElement('div');
        slide.className = 'ab-fs-product-carousel__slide';
        slide.appendChild(link);
        if (options) {
          var extras = [options];
          var sibling = options.nextElementSibling;
          while (
            sibling &&
            !sibling.matches('.fs-shop-link, .fs-shopify-options, .fs-product-column, .ab-fs-product-carousel')
          ) {
            extras.push(sibling);
            sibling = sibling.nextElementSibling;
          }
          extras.forEach(function (node) {
            slide.appendChild(node);
          });
        }
        return slide;
      });

      var carousel = document.createElement('div');
      carousel.className = 'ab-fs-product-carousel';

      var viewport = document.createElement('div');
      viewport.className = 'ab-fs-product-carousel__viewport';

      var track = document.createElement('div');
      track.className = 'ab-fs-product-carousel__track';
      slides.forEach(function (slide) {
        track.appendChild(slide);
      });
      viewport.appendChild(track);

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'ab-fs-product-carousel__btn ab-fs-product-carousel__btn--prev';
      prev.setAttribute('aria-label', 'Previous product');
      prev.textContent = '‹';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'ab-fs-product-carousel__btn ab-fs-product-carousel__btn--next';
      next.setAttribute('aria-label', 'Next product');
      next.textContent = '›';

      var dots = document.createElement('div');
      dots.className = 'ab-fs-product-carousel__dots';
      var index = 0;

      function goTo(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        Array.prototype.forEach.call(dots.children, function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      slides.forEach(function (_, slideIndex) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ab-fs-product-carousel__dot' + (slideIndex === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Show product ' + (slideIndex + 1));
        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          goTo(slideIndex);
        });
        dots.appendChild(dot);
      });

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index - 1);
      });
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index + 1);
      });

      carousel.appendChild(prev);
      carousel.appendChild(viewport);
      carousel.appendChild(next);
      carousel.appendChild(dots);

      productsRoot.innerHTML = '';
      productsRoot.appendChild(carousel);
      productsRoot.dataset.abCarousel = 'true';
    });
  }

  function collapseAll() {
    document.querySelectorAll(homepageSelector).forEach(collapseGallery);
    initProductCarousels();
  }

  var scheduled = false;
  function scheduleCollapse() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      collapseAll();
    });
  }

  function retryCarousels() {
    [0, 150, 400, 900].forEach(function (delay) {
      setTimeout(initProductCarousels, delay);
    });
  }

  var galleryObserver = new MutationObserver(scheduleCollapse);
  var lightboxObserver = new MutationObserver(function () {
    observeLightbox();
    scheduleCollapse();
    retryCarousels();
  });

  function observeLightbox() {
    document
      .querySelectorAll('.fs-prepended-detail, .fs-timeline-detail, .fs-detail-container, #fs-detail-products')
      .forEach(function (root) {
        lightboxObserver.observe(root, { childList: true, subtree: true });
      });
  }

  function observeRoots() {
    document.querySelectorAll(rootSelector).forEach(function (root) {
      galleryObserver.observe(root, { childList: true, subtree: true });
    });
    if (document.body) {
      lightboxObserver.observe(document.body, { childList: true });
    }
    observeLightbox();
  }

  document.addEventListener('DOMContentLoaded', collapseAll);
  window.addEventListener('load', collapseAll);
  window.addEventListener('resize', scheduleCollapse);
  document.addEventListener(
    'foursixtyDetailOpened',
    function () {
      observeLightbox();
      retryCarousels();
    },
    true
  );
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.ab-foursixty .fs-timeline-entry')) {
      observeLightbox();
      retryCarousels();
    }
  });

  observeRoots();
  document.addEventListener('shopify:section:load', function () {
    collapseAll();
    observeRoots();
  });
})();
